import '../App.css';
import { useState, useEffect } from "react";
import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";

export default function ShowAlert({ variant, message }) {
  const [alerttyp] = useState(variant === "danger" ? "Problem!" : "Success!" );
  const [alerticon] = useState(variant === "danger" ? <AiFillCloseCircle className='dang' /> : <AiFillCheckCircle className='sucs' /> );
   const [isShown, setIsShown] = useState(false); // State to control visibility of the alert

  useEffect(() => {
    // Set isShown to true after the component is rendered
    setIsShown(true);
  }, []);

  return (
    <div className={`alertContainer slide-in ${variant} ${isShown ? "show" : "hide"}`}>
      <div className='leftpartAlert'>
        <div className="alerticon">{alerticon}</div>
      </div>
      <div className='rightpartAlert'>
        <div className="alerttype">{alerttyp}</div>
        <div>{message}</div> 
        <div className="alerttime">{new Date().toLocaleTimeString()}</div>
      </div>
     
    </div>
    // <Alert className={variant} key={variant} variant={variant}>
    //   {message}
    // </Alert>
  );
}
